<template>
  <Visitor title="Publicar Servicio">
    <main>
      <div class="max-w-5xl mx-auto py-4 px-4 sm:px-6 lg:px-10 rounded-b-lg">
        <SearchBar />
      </div>
      <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <CategorySelector @onCategorySelected="filterByCategory"/>
        <ServiceList :category="category"/>
      </div>
    </main>
  </Visitor>
</template>

<script>
import SearchBar from "../components/SearchBar.vue";
import CategorySelector from "../components/CategorySelector.vue";
import ServiceList from '../containers/ServiceList.vue'
import Visitor from './Layouts/Visitor.vue'

export default {
  name: "LandingPage",
  components: {
    SearchBar,
    CategorySelector,
    ServiceList,
    Visitor
  },
  data() {
    return {
      category: 'all'
    }
  },
  methods: {
    filterByCategory(newCategory) {
      this.category = newCategory
    }
  }
}
</script>